const adminPermissions = [
	"dashboard:view",
	"drawer-admin-items:view",
	"tickets-manager:showall",
	"user-modal:editProfile",
	"user-modal:editQueues",
	"ticket-options:deleteTicket",
	"contacts-page:deleteContact",
	"connections-page:actionButtons",
	"connections-page:addConnection",
	"connections-page:editOrDeleteConnection",
	"tickets-manager:closeAll",
	"dashboard:kanban",
	"dashboard:tags",
	"dashboard:products",
	"dashboard:campaigns",
	"dashboard:flowbuilders",
	"dashboard:schedules"
];

const rules = {
	user: {
		static: [
			'dashboard:viewLink',
			'dashboard:products'
		],
	},

	admin: {
		static: adminPermissions,
	},

	root: {
		static: [
			...adminPermissions,
			"companies:create",
			"settings:global"
		],
	},
};

export default rules;
